let apiUrl = process.env.REACT_APP_API_URL;
let queryString = "?XDEBUG_SESSION_START=PHPSTORM";

if (process.env.REACT_APP_ENV == "qa" && window.location.protocol === 'https:')
  apiUrl = "https://central.fifostage.com/backend/public";

export { apiUrl, queryString };